import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './store'
import App from './App'
import './index.css'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
  },
])

// ,
//   {
//     path: '/reports',
//     element: <CountryReport />,
//   },

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>,
)

// ,
//   "resolutions": {
//     "string-width": "^4",
//     "strip-ansi": "^6.0.1",
//     "jackspeak": "^2.1.1"
//   }
